import { Icons } from '@/components/Icon'
import InfoBlocks from '@/components/InfoBlocks'
import { determineRank } from '../utils'

const RankInfoBlock = ({
  label = 'Current Rank',
  rank
}: {
  label?: string
  rank: number
}) => {
  const isBelowThreshold = determineRank(rank) === 'Ineligible'
  const icon: Icons = isBelowThreshold ? 'trophyIneligible' : 'trophy'
  const iconColor = isBelowThreshold ? 'muted' : 'arcade'

  return (
    <InfoBlocks
      definitions={[
        {
          label,
          valueIcon: {
            name: icon,
            color: iconColor
          },
          value: {
            type: 'numeric',
            value: rank
          }
        }
      ]}
    />
  )
}

export default RankInfoBlock
